import {useCourseWithInstructorDetailsContext} from '@/features/course-landing-page/context/course-with-instructor-details-provider.react-component';

/**
 * Returns the instructor details for the given instructor id.
 * @param instructorId - The id of the instructor to get the details for.
 * @returns The instructor details for the given instructor id.
 */
export const useInstructorDetails = () => {
    const {instructorDetails} = useCourseWithInstructorDetailsContext();
    return instructorDetails;
};
